module.exports = __webpack_public_path__ + "img/AK0091-LU.b9c3847f.jpg";